import React from "react";
import NavBar from "../../NavBar";
import "./Banner.css";

const Banner: React.FC = () => {
  return (
    <div className="banner">
      <NavBar isOpaque={false} />
      <div className="banner-background">
        {/* Main background image with rounded bottom borders */}
        <div className="banner-main-image"></div>

        {/* Logos row in bottom left corner */}
        <div className="banner-logos">
          <a
            href="https://ufrj.br"
            target="_blank"
            rel="noopener noreferrer"
            className="logo-link"
          >
            <img
              src="ufrj_branco.png"
              alt="UFRJ"
              className="logo-image logo-ufrj"
            />
          </a>
          <a
            href="https://ccmn.ufrj.br"
            target="_blank"
            rel="noopener noreferrer"
            className="logo-link"
          >
            <img
              src="ccmn_branco.png"
              alt="CCMN"
              className="logo-image logo-ccmn"
            />
          </a>
          <a
            href="https://cla.ufrj.br"
            target="_blank"
            rel="noopener noreferrer"
            className="logo-link"
          >
            <img
              src="cla_branco.png"
              alt="CLA"
              className="logo-image logo-cla"
            />
          </a>
        </div>

        {/* Overlay PNG image in bottom right corner */}
        <div className="banner-overlay-image">
          <img
            src="texture/blob.png"
            alt="LaRC Overlay"
            className="overlay-image"
          />
        </div>
        <div className="banner-overlay-image">
          <img
            src="larchorizontal.png"
            alt="LaRC Overlay"
            className="overlay-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
